export const playbackEvents = {
  SKIP_PAUSE: 'skip_pause',
  SKIP_PLAY: 'skip_play',
  PLAY: 'play',
  PAUSE: 'pause',
}
